var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"javascript:void(0)","title":_vm.tagName},on:{"click":function($event){$event.preventDefault();return _vm.tagFiltering($event)}}},[_vm._v("\n        #"+_vm._s(_vm.tagName)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }